<template>
  <div v-redirect-if-no-permission:COMPLAINTS class="complaints-main-container">
    <h1>{{ $t("monitoring.complaintsList.complaintsList") }}</h1>
    <p>{{ $t("monitoring.complaintsList.filters") }}</p>
    <div class="filters">
      <choose-captains-multi style="width: 100%" v-model="captains" return-object :multi="true"
        :label="$t('monitoring.complaintsList.selectCaptain')" />
      <choose-passenger-multi :label="$t('monitoring.complaintsList.choosePassenger')" style="width: 100%" return-object :multi="true"
        v-model="passengers" url="passenger_numbers" />

      <choose-date v-model="startDate" style="width: 100%" :label="$t('monitoring.complaintsList.startDate')" />
      <choose-date v-model="endDate" style="width: 100%" :label="$t('monitoring.complaintsList.endDate')" />
    </div>
    <v-data-table :url="url" :headers="headers" :items="data" :pagination.sync="pagination" :total-items="totalItems"
      :rows-per-page-items="[5, 10, 15, 25, 100]" :loading="loading">
      <template v-slot:items="props">
        <tr
          :class="[$store.state.user.roles[0].name != 'Goverment' ? '' : props.item.complaint_status == 'Not Treated' ? 'not-treated' : props.item.complaint_status == 'Treated' ? 'treated' : 'partially-treated']">
          <td class="text-xs-center">{{ props.index + 1 }}</td>

          <td class="text-xs-center">
            {{ props.item.booking_id }}
          </td>
          <td class="text-xs-center">{{ props.item.username }}</td>
          <td class="text-xs-center">{{ props.item.datetime ? moment(props.item.datetime).format("DD-MM-YYYY - HH:mm"): "-"}}</td>
          <td class="text-xs-center">{{ props.item.first_complaint_created_at ? moment(props.item.first_complaint_created_at).format("DD-MM-YYYY - HH:mm"): "-"}}</td>
          <td class="text-xs-center">{{ props.item.first_category }}</td>
          <td class="text-xs-center">{{ props.item.count }}</td>
          <td class="text-xs-center">
            <v-icon @click="bookingProfile(props.item)">info</v-icon>
          </td>
        </tr>

      </template>
    </v-data-table>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import ChoosePassengerMulti from "@/components/monaco/input/ChoosePassengerMulti";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import moment from "moment";
export default {
  name: "ComplaintsList",
  title() {
    return this.$t("monitoring.complaintsList.title");
  },
  components: {
    DataTable,
    ChooseCaptainsMulti,
    ChoosePassengerMulti,
    ChooseDate,
  },
  data() {
    return {
      url: "complaint",
      captains: [],
      passengers: [],
      totalItems: 0,
      startDate: null,
      endDate: null,
      data: [],
      titles: {
        id: "#",
        booking_id: "Booking ID",
        type: "Who complained",
        entity_id: "Captain/Order ID",
        description: "Description",
        updated_at: "Last updated at",
        created_at: "Created at",
      },
      pagination: {
        sortBy: "booking_id",
        rowsPerPage: 100,
      },
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    headers() {
      return [
        { text: "#", value: "id", sortable: false, align: "center" },

        // {
        //   text: "Captain ID",
        //   value: "username",
        //   sortable: false,
        //   align: "center",
        // },
        {
          text: this.$t("monitoring.complaintsList.bookingId"),
          value: "booking_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("monitoring.complaintsList.licenseNumber"),
          value: "username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("monitoring.complaintsList.bookingTime"),
          value: "datetime",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("monitoring.complaintsList.creationTime"),
          value: "first_complaint_created_at",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("monitoring.complaintsList.category"),
          value: "category",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("monitoring.complaintsList.count"),
          value: "count",
          sortable: false,
          align: "center",
        },
        // {
        //   text: "Description",
        //   value: "description",
        //   sortable: false,
        //   align: "center",
        // },
        // {
        //   text: "Created at",
        //   value: "created_at",
        //   sortable: false,
        //   align: "center",
        // },
      ];
    },
    params() {
      const params = new URLSearchParams();
      if (this.captains.length)
        params.append(
          "captains",
          this.captains.map((item) => item.id).join(",")
        );
      if (this.passengers.length)
        params.append(
          "passengers",
          this.passengers.map((item) => item.id).join(",")
        );
      if (this.startDate) params.append("from", this.startDate);
      if (this.endDate) params.append("to", this.endDate);
      params.append("perPage", String(this.pagination.rowsPerPage));
      params.append("page", this.pagination.page);
      return params;
    },
    actions() {
      return {
        details: {
          title: "details",
          icon: "info",
          action: (item) => {
            this.$router.push({ path: `/rides/${item.booking_id}` });
          },
        },
      };
    },
  },
  methods: {
    bookingProfile(val) {
      //console.log(val)
      if (val.booking_id)
        window.open(`/rides/${val.booking_id}`, "_blank");
      else
        this.showDetails({ ...val, id: val.first_complaint_id }, val.first_complaint_id);
    },
    getData() {
      this.loading = true;
      this.axios
        .get(`complaint`, {
          params: this.params,
        })
        .then((res) => {
          console.log("data");
          console.log(this.data);
          this.pagination.rowsPerPage = Number(res.data.data.per_page);
          this.data = res.data.data.data;
          this.totalItems = res.data.data.total;

          this.loading = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
    ellipsify(str) {
      if (str.length > 10) {
        return str.substring(0, 10) + "...";
      } else {
        return str;
      }
    },
    showDetails(complaint, id) {
      const audioPromise = this.axios.get(`complaint/${id}/audio`);
      const commentPromise = this.axios.get(`complaint_comments/${id}/get_comments`);
      const infoPromise = this.axios.get(`complaint-details/${id}`);
      Promise.allSettled([audioPromise, commentPromise, infoPromise]).then(([audios, comments, info]) => {
        if (info.status === "fulfilled" && info.value.data.data)
          Object.assign(complaint, info.value.data.data);
        complaint.audios = audios.value.data.data;
        complaint.comments = comments.value.data.data;
        complaint.comments.forEach(comment => {
          comment.audios = comment.audios.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
        });
        this.$complaintDialog({
          complaint: complaint,
          hideCancel: true,
          fileUpload: this.$t("monitoring.complaintsList.soundFiles"),
          list: audios.value.data.data,
          additionalData: {
            id: id
          }
        })
      });
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    params: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.not-treated {
  td {
    background-color: rgba(220, 39, 39, 0.08);
    border-radius: 4px;
    color: rgb(220, 39, 39);
  }
}

.treated {
  td {
    background-color: rgba(99, 228, 24, 0.08);
    border-radius: 4px;
    color: rgb(5, 116, 51);
  }
}

.partially-treated {
  td {
    background-color: rgba(252, 179, 45, 0.08);
    border-radius: 4px;
    color: rgb(252, 179, 45);
  }
}

.complaints-main-container {
  float: left;
  width: 100%;
  height: auto;
  padding: 18px;
  background: #fff;

  .filters {
    width: 100%;
    float: left;
    display: flex;
    justify-content: flex-start;
    gap: 12px;
  }

  h1 {
    width: 100%;
    float: left;
    height: auto;
    text-align: left;
    font-size: 14pt;
    color: #202731;
    font-weight: 500;
  }

  p {
    width: 100%;
    margin-bottom: 0;
    margin-top: 6px;
    float: left;
    color: #7f949d;
  }
}
</style>
